<template>
  <app-page>
    <template #actions>
      <app-icon-button icon="refresh" label="Aktualisieren" @click="refreshDataGrid" />
    </template>
    <template #toolbar-end>
      <app-search
        v-model="searchText"
        placeholder="In Tickets suchen"
        @input="onSearchInput"
      />
    </template>
    <dx-data-grid
      :ref="gridRefName"
      :columns="columns"
      :master-detail="masterDetail"
      :data-source="dataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :remote-operations="true"
      :scrolling="scrolling"
      :element-attr="gridAttr"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <dx-search-panel :visible="false" />

      <dx-editing
        refresh-mode="full"
        :allow-adding="false"
        :allow-updating="false"
        :allow-deleting="false"
        mode="batch"
      />

      <dx-pager
        :show-page-size-selector="false"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :visible="true"
        :info-text="'Seite {0} von {1} ({2} Tickets)'"
        :show-navigation-buttons="true"
      />
      <dx-filter-row :visible="true" />
      <dx-paging :page-size="10" />
      <dx-export :enabled="false" />

      <template #masterDetailTemplate="row">
        <TicketEventDataGrid
          :ticket_id="row.data.data.id"
          class="mx-5"
        ></TicketEventDataGrid>
      </template>
    </dx-data-grid>
  </app-page>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxEditing,
  DxSearchPanel,
  DxExport,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import DataSource from "devextreme/data/data_source";
import axios from "axios";
import TicketEventDataGrid from "@/components/TicketEventDataGrid";

export default {
  components: {
    DxDataGrid,
    DxPager,
    DxFilterRow,
    DxPaging,
    DxEditing,
    DxSearchPanel,
    DxExport,
    TicketEventDataGrid
  },
  mixins: [DataGridMixin],
  computed: {},
  watch: {},
  data() {
    return {
      gridRefName: "eticketTicketGrid",
      searchText: "",
      gridAttr: {},
      masterDetail: {
        enabled: true,
        template: "masterDetailTemplate",
      },
      columns: [
        {
          dataField: "id",
          caption: "Ticket ID",
        },
        {
          dataField: "status",
          caption: "Status",
        },
      ],
      dataSource: new DataSource({
        load: async (loadOptions) => {
          const data = (
            await axios.get(
              `${
                this.$store.state.baseUrl
              }eticket-ticket?loadOptions=${encodeURIComponent(
                JSON.stringify(loadOptions)
              )}`
            )
          ).data;
          return data;
        },
      }),
    };
  },
  methods: {
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    // Suche und Aktualisieren stehen in Seitenkopf und Werkzeugleiste; die DX-Werkzeugleiste bleibt leer
    onToolbarPreparing(e) {
      e.toolbarOptions.items = [];
    },
    onSearchInput() {
      this.$refs[this.gridRefName].instance.searchByText(this.searchText);
    },
  },
};
</script>
